"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DropdownNoOptionsTextWrapper = exports.DropdownNoOptionsContainer = exports.DropdownNoOptionsAddButtonText = exports.DropdownNoOptionsAddButton = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledIs = _interopRequireDefault(require("../../utils/styled-is"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Plus = _interopRequireDefault(require("@honeybook/icons/dist/icons/Plus16"));
var _HBText = _interopRequireDefault(require("../HBText/HBText"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _templateObject;
var HBDropdownNoOptions = function HBDropdownNoOptions(_ref) {
  var value = _ref.value,
    dropdownNoOptionsExplanation = _ref.dropdownNoOptionsExplanation,
    _ref$noOptionsButtonT = _ref.noOptionsButtonText,
    noOptionsButtonText = _ref$noOptionsButtonT === void 0 ? 'Add' : _ref$noOptionsButtonT,
    _ref$showPlusIcon = _ref.showPlusIcon,
    showPlusIcon = _ref$showPlusIcon === void 0 ? true : _ref$showPlusIcon,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'blue20' : _ref$color;
  return /*#__PURE__*/_react["default"].createElement(DropdownNoOptionsContainer, {
    title: "",
    hasExplanationText: !!dropdownNoOptionsExplanation
  }, dropdownNoOptionsExplanation && /*#__PURE__*/_react["default"].createElement(DropdownNoOptionsTextWrapper, null, /*#__PURE__*/_react["default"].createElement(_HBText["default"], {
    type: "caption12",
    color: "textSecondary"
  }, dropdownNoOptionsExplanation)), /*#__PURE__*/_react["default"].createElement(DropdownNoOptionsAddButton, null, showPlusIcon && /*#__PURE__*/_react["default"].createElement(_Plus["default"], {
    color: _colors["default"][color]
  }), /*#__PURE__*/_react["default"].createElement(DropdownNoOptionsAddButtonText, {
    type: "emphasis14",
    color: color
  }, !!value ? "".concat(noOptionsButtonText, " \"").concat(value, "\"") : noOptionsButtonText)));
};
var _default = exports["default"] = HBDropdownNoOptions;
var DropdownNoOptionsTextWrapper = exports.DropdownNoOptionsTextWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HBDropdownNoOptions__DropdownNoOptionsTextWrapper",
  componentId: "sc-11q4faz-0"
})(["padding:7px 0 7px 3px;white-space:break-spaces;line-height:15px;"]);
var DropdownNoOptionsAddButton = exports.DropdownNoOptionsAddButton = _styledComponents["default"].div.withConfig({
  displayName: "HBDropdownNoOptions__DropdownNoOptionsAddButton",
  componentId: "sc-11q4faz-1"
})(["display:flex;justify-content:flex-start;align-items:center;"]);
var DropdownNoOptionsAddButtonText = exports.DropdownNoOptionsAddButtonText = (0, _styledComponents["default"])(_HBText["default"]).withConfig({
  displayName: "HBDropdownNoOptions__DropdownNoOptionsAddButtonText",
  componentId: "sc-11q4faz-2"
})(["margin-left:8px;"]);
var DropdownNoOptionsContainer = exports.DropdownNoOptionsContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBDropdownNoOptions__DropdownNoOptionsContainer",
  componentId: "sc-11q4faz-3"
})(["", ""], (0, _styledIs["default"])('hasExplanationText')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n        ", " {\n            padding: 2px 5px 10px;\n        }\n    "])), DropdownNoOptionsAddButton));
//# sourceMappingURL=HBDropdownNoOptions.js.map